import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import { withStyles, createStyles } from '@material-ui/core';
import ButtonBase from '@material-ui/core/ButtonBase';
import Icon from '../../../../core/Icon';
var styles = createStyles({
  root: {
    height: 'auto',
    cursor: 'pointer',
    display: 'inline-block'
  },
  sortable: {
    position: 'relative',
    top: 2,
    paddingLeft: 3,
    fontWeight: 'bold',
    display: 'inline-flex',
    opacity: 0.3,
    fontSize: '1rem'
  },
  direction: {
    margin: '0 0 0 5px',
    display: 'inline-flex',
    fontSize: 14
  }
});
var TableSortLabel = React.forwardRef(
/** @param {import('./types').DataGridViewDetailTableSortLabelProps & import('@material-ui/core').WithStyles} props */
function (_ref, ref) {
  var active = _ref.active,
      classes = _ref.classes,
      className = _ref.className,
      children = _ref.children,
      direction = _ref.direction,
      other = _objectWithoutProperties(_ref, ["active", "classes", "className", "children", "direction"]);

  return React.createElement(ButtonBase, Object.assign({
    ref: ref,
    classes: {
      root: classes.root
    },
    component: "span",
    disableRipple: true
  }, other), children, React.createElement(Icon, {
    type: direction === 'asc' ? 'sortAsc' : 'sortDesc',
    style: active ? {
      display: 'inline-flex'
    } : {
      display: 'none'
    },
    className: classes.direction
  }), React.createElement(Icon, {
    type: "sortable",
    className: classes.sortable,
    style: {
      paddingLeft: active ? 0 : 5
    }
  }));
});
TableSortLabel.defaultProps = {
  active: false,
  direction: 'desc'
};
export default withStyles(styles, {
  name: 'MuiTableSortLabel'
})(TableSortLabel);